<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="content">
            <div class="confirmation-success">
              <div class="confirmation-success__icon">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="40" cy="40" r="40" fill="#EEF4FF" />
                  <path
                    d="M54.6667 33L35.5 52.1667L25.3333 42"
                    stroke="#0153FD"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <h1 class="confirmation-success__title">
                {{ $t(`Transaction Confirmed`) }}
              </h1>

              <p class="confirmation-success__message" v-if="alreadyConfirmed">
                {{
                  $t(
                    `This transaction has already been confirmed. No further action is needed.`
                  )
                }}
              </p>

              <p class="confirmation-success__message" v-else>
                {{ $t(`Your transaction has been successfully confirmed.`) }}
              </p>

              <div class="instruction-message" v-if="!alreadyConfirmed">
                {{
                  $t(
                    `Please return to the original browser tab where you started your transaction. The process will continue automatically there.`
                  )
                }}
              </div>

              <div class="buttons">
                <button class="button gray" @click="goToHome">
                  {{ $t(`Go to Home`) }}
                </button>
                <button class="button" @click="goToBuyCrypto">
                  {{ $t(`Buy More Crypto`) }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "ConfirmationSuccessPage",
  data() {
    return {
      alreadyConfirmed: false,
    };
  },
  methods: {
    goToHome() {
      this.$router.push({ path: "/" });
    },
    goToBuyCrypto() {
      this.$router.push({ path: "/buy-crypto" });
    },
  },
  mounted() {
    this.alreadyConfirmed = this.$route.query.already === "true";
  },
};
</script>

<style scoped>
.page-inside {
  line-height: 1;
}

.confirmation-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #ffffff;
  border-radius: 16px;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.confirmation-success__icon {
  margin-bottom: 24px;
}

.confirmation-success__title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

.confirmation-success__message {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 18px;
  line-height: 1.5;
}

.instruction-message {
  font-size: 14px;
  color: #1e293b;
  margin-bottom: 24px;
  padding: 12px 16px;
  background-color: #f8fafc;
  border-left: 3px solid #0153fd;
  border-radius: 4px;
  text-align: left;
  width: 100%;
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-items: center;
}

.buttons .button {
  max-width: 260px;
}

@media (max-width: 480px) {
  .confirmation-success {
    padding: 30px 16px;
  }

  .confirmation-success__title {
    font-size: 20px;
  }

  .confirmation-success__message {
    font-size: 14px;
  }

  .instruction-message {
    font-size: 13px;
    padding: 10px 14px;
  }
}
</style>

